import { ErrorView } from './ErrorView.js';

export function ForbiddenView(): JSX.Element {
  return (
    <ErrorView
      code="403"
      description="You don't have permission to access this page. Contact an administrator if you think this is a mistake."
      title="Access denied"
    />
  );
}
